import { Link } from 'react-router-dom';

/**
 * Página "En construcción" de los agentes del roadmap (Prefactibilidad / DIA / EIA):
 * ilustración propia de línea (obrero con pala y picota, trazo azul corporativo +
 * acentos celestes) sobre una card centrada. Sin emojis ni stock: dibujo de la casa.
 */

function Obrero() {
  return (
    <svg
      viewBox="0 0 240 200"
      role="img"
      aria-label="Obrero con pala y picota trabajando en la construcción de esta sección"
      className="mx-auto h-44 w-auto sm:h-52"
      fill="none"
      stroke="#00428D"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Suelo */}
      <path d="M24 168h192" strokeDasharray="1 7" strokeWidth="2.6" />
      <path d="M150 168c4-6 14-6 18 0" />
      <circle cx="60" cy="168" r="1.4" fill="#688EC8" stroke="none" />
      <circle cx="140" cy="173" r="1.4" fill="#688EC8" stroke="none" />
      <circle cx="200" cy="172" r="1.4" fill="#688EC8" stroke="none" />

      {/* Picota clavada en el suelo */}
      <path d="M196 112 178 168" />
      <path d="M180 106q18-12 36 2" fill="#EAF4FB" />
      <path d="M180 106q18-12 36 2-18-6-36-2z" fill="#98D0EB" fillOpacity="0.55" />

      {/* Obrero apoyado en la pala */}
      {/* casco */}
      <path d="M95 60a13 12 0 0 1 26 0" fill="#98D0EB" fillOpacity="0.6" />
      <path d="M91 61h34" />
      <path d="M108 48v-4" />
      {/* cabeza */}
      <circle cx="108" cy="70" r="10" fill="#fff" />
      <circle cx="111.5" cy="69" r="1.1" fill="#010F27" stroke="none" />
      <path d="M110 75q3 2 6 0" strokeWidth="1.6" />
      {/* torso */}
      <path d="M106 80c-3 12-3 24-1 34" />
      {/* brazos hacia la pala */}
      <path d="M106 90c8 2 16 6 24 10" />
      <path d="M105 100c8 3 15 7 22 12" />
      {/* piernas */}
      <path d="M105 114c-2 18-5 36-9 52" />
      <path d="M107 114c4 18 7 36 9 52" />
      <path d="M96 166h-9" />
      <path d="M116 166h9" />
      {/* pala */}
      <path d="M131 98c3 16 5 32 6 48" />
      <path d="M125 94l12 6" />
      <path d="M129 146c-2 10 2 20 8 24 6-4 8-14 6-24z" fill="#EAF4FB" />

      {/* Chispas del trabajo */}
      <path d="M52 96l3 3M58 90l-3 3" strokeWidth="1.6" stroke="#688EC8" />
      <path d="M226 84l3 3M232 78l-3 3" strokeWidth="1.6" stroke="#688EC8" />
      <circle cx="70" cy="120" r="1.6" fill="#98D0EB" stroke="none" />
      <circle cx="216" cy="132" r="1.6" fill="#98D0EB" stroke="none" />
    </svg>
  );
}

export default function EnConstruccionAgente({
  nombre,
  descripcion,
}: {
  nombre: string;
  descripcion: string;
}) {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <section className="tarjeta w-full max-w-xl px-6 py-12 text-center sm:px-12">
        <Obrero />
        <p className="mt-8 text-[10px] font-medium uppercase tracking-[0.22em] text-azul-medio">
          Agentes AMBEC · En construcción
        </p>
        <h1 className="mt-2 text-xl font-medium tracking-tight text-azul-noche">
          {nombre} llega pronto
        </h1>
        <p className="mx-auto mt-3 max-w-md text-sm font-light leading-relaxed text-texto">
          Nuestro equipo está construyendo este agente. Cuando esté listo, aquí podrás {descripcion}.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link to="/panel" className="btn-secundario">
            Volver al Panel
          </Link>
          <Link to="/newsletter" className="btn-primario">
            Ir al Newsletter
          </Link>
        </div>
      </section>
    </div>
  );
}
